import React from 'react';
import _ from 'lodash';

import {
  Backdrop,
  SpeedDial,
  SpeedDialAction
} from '@mui/material';

import { HomeRepairService } from '@mui/icons-material';



export interface IOption {
  elIcon: JSX.Element;
  id: string;
  label: string;
  show?: boolean;
}

export interface IProps {
  elIcon?: JSX.Element;
  options: IOption[];

  onClickOption: (optionId: string) => void;
}

export const FC: React.FC<IProps> = props => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Backdrop open={open} />

      <SpeedDial
        open={open}
        ariaLabel="SpeedDial basic example"
        sx={{
          position: 'fixed',
          bottom: theme => theme.spacing(2),
          right: theme => theme.spacing(2)
        }}
        icon={props.elIcon ?? <HomeRepairService />}
        onClick={() => setOpen(prev => !prev)}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}>
        {props.options.filter(opt => _.isNil(opt.show) || opt.show).map(option => (
          <SpeedDialAction
            key={option.id}
            icon={option.elIcon}
            tooltipOpen
            tooltipTitle={option.label}
            onClick={() => props.onClickOption(option.id)}
          />
        ))}
      </SpeedDial>
    </>
  );
};
